var ol = require('../dist/ol-debug');
// VFL переопределение конструктора ol.style.Text
// добавлен атрибут перекрытий
var olStyleText = function (opt_options) {

    var options = opt_options || {};

    /**
     * @private
     * @type {string|undefined}
     */
    this.font_ = options.font;

    /**
     * @private
     * @type {number|undefined}
     */
    this.rotation_ = options.rotation;

    /**
     * @private
     * @type {boolean|undefined}
     */
    this.rotateWithView_ = options.rotateWithView;

    /**
     * @private
     * @type {number|undefined}
     */
    this.scale_ = options.scale;

    /**
     * @private
     * @type {string|undefined}
     */
    this.text_ = options.text;

    /**
     * @private
     * @type {string|undefined}
     */
    this.textAlign_ = options.textAlign;

    /**
     * @private
     * @type {string|undefined}
     */
    this.textBaseline_ = options.textBaseline;

    /**
     * @private
     * @type {import("./Fill.js").default}
     */
    this.fill_ = options.fill !== undefined ? options.fill :
        new ol.style.Fill({color: ol.style.Text.DEFAULT_FILL_COLOR});

    /**
     * @private
     * @type {number}
     */
    this.maxAngle_ = options.maxAngle !== undefined ? options.maxAngle : Math.PI / 4;

    /**
     * @private
     * @type {import("./TextPlacement.js").default|string}
     */
    this.placement_ = options.placement !== undefined ? options.placement : ol.style.TextPlacement.POINT;

    /**
     * @private
     * @type {boolean}
     */
    this.overflow_ = !!options.overflow;

    /**
     * @private
     * @type {import("./Stroke.js").default}
     */
    this.stroke_ = options.stroke !== undefined ? options.stroke : null;

    /**
     * @private
     * @type {number}
     */
    this.offsetX_ = options.offsetX !== undefined ? options.offsetX : 0;

    /**
     * @private
     * @type {number}
     */
    this.offsetY_ = options.offsetY !== undefined ? options.offsetY : 0;

    /**
     * @private
     * @type {import("./Fill.js").default}
     */
    this.backgroundFill_ = options.backgroundFill ? options.backgroundFill : null;

    /**
     * @private
     * @type {import("./Stroke.js").default}
     */
    this.backgroundStroke_ = options.backgroundStroke ? options.backgroundStroke : null;

    /**
     * @private
     * @type {Array<number>}
     */
    this.padding_ = options.padding === undefined ? null : options.padding;

    // VFL добавлен атрибут перекрытий
    // по умолчанию true (в отличии от мапника), т.к. в проектах по умолчанию тексты могут перекрываться
    /**
     * @private
     * @type {boolean}
     */
    this.overlap_ = options.overlap !== undefined ? options.overlap : true;
};

olStyleText.prototype = {};

ol.inherits(olStyleText, ol.style.Text);

ol.style.Text = olStyleText;

// VFL геттер атрибута перекрытий текта
ol.style.Text.prototype.getOverlap = function () {
    return this.overlap_;
};

// VFL сеттер атрибута перекрытий текстов
ol.style.Text.prototype.setOverlap = function (overlap) {
    this.overlap_ = overlap;
};

// VFL клонирование с учетом перекрытий текстов
ol.style.Text.prototype.clone = function () {
    return new Text({
        font: this.getFont(),
        placement: this.getPlacement(),
        maxAngle: this.getMaxAngle(),
        overflow: this.getOverflow(),
        rotation: this.getRotation(),
        rotateWithView: this.getRotateWithView(),
        scale: this.getScale(),
        text: this.getText(),
        textAlign: this.getTextAlign(),
        textBaseline: this.getTextBaseline(),
        fill: this.getFill() ? this.getFill().clone() : undefined,
        stroke: this.getStroke() ? this.getStroke().clone() : undefined,
        offsetX: this.getOffsetX(),
        offsetY: this.getOffsetY(),
        backgroundFill: this.getBackgroundFill() ? this.getBackgroundFill().clone() : undefined,
        backgroundStroke: this.getBackgroundStroke() ? this.getBackgroundStroke().clone() : undefined,
        // VFL клонирование с учетом перекрытий текстов
        overlap: this.getOverlap()
    });
};


// VFL
// добавлен атрибут перекрытий textOverlap
ol.render.canvas.Immediate.prototype.setTextStyle = function (textStyle) {
    if (!textStyle) {
        this.text_ = '';
    } else {
        var textFillStyle = textStyle.getFill();
        if (!textFillStyle) {
            this.textFillState_ = null;
        } else {
            var textFillStyleColor = textFillStyle.getColor();
            this.textFillState_ = {
                fillStyle: ol.colorlike.asColorLike(textFillStyleColor ?
                    textFillStyleColor : ol.render.canvas.defaultFillStyle)
            };
        }
        var textStrokeStyle = textStyle.getStroke();
        if (!textStrokeStyle) {
            this.textStrokeState_ = null;
        } else {
            var textStrokeStyleColor = textStrokeStyle.getColor();
            var textStrokeStyleLineCap = textStrokeStyle.getLineCap();
            var textStrokeStyleLineDash = textStrokeStyle.getLineDash();
            var textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
            var textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
            var textStrokeStyleWidth = textStrokeStyle.getWidth();
            var textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
            this.textStrokeState_ = {
                lineCap: textStrokeStyleLineCap !== undefined ?
                    textStrokeStyleLineCap : ol.render.canvas.defaultLineCap,
                lineDash: textStrokeStyleLineDash ?
                    textStrokeStyleLineDash : ol.render.canvas.defaultLineDash,
                lineDashOffset: textStrokeStyleLineDashOffset ?
                    textStrokeStyleLineDashOffset : ol.render.canvas.defaultLineDashOffset,
                lineJoin: textStrokeStyleLineJoin !== undefined ?
                    textStrokeStyleLineJoin : ol.render.canvas.defaultLineJoin,
                lineWidth: textStrokeStyleWidth !== undefined ?
                    textStrokeStyleWidth : ol.render.canvas.defaultLineWidth,
                miterLimit: textStrokeStyleMiterLimit !== undefined ?
                    textStrokeStyleMiterLimit : ol.render.canvas.defaultMiterLimit,
                strokeStyle: ol.colorlike.asColorLike(textStrokeStyleColor ?
                    textStrokeStyleColor : ol.render.canvas.defaultStrokeStyle)
            };
        }
        var textFont = textStyle.getFont();
        var textOffsetX = textStyle.getOffsetX();
        var textOffsetY = textStyle.getOffsetY();
        var textRotateWithView = textStyle.getRotateWithView();
        var textRotation = textStyle.getRotation();
        var textScale = textStyle.getScale();
        var textText = textStyle.getText();
        var textTextAlign = textStyle.getTextAlign();
        var textTextBaseline = textStyle.getTextBaseline();
        // VFL свойство перекрытия
        var textOverlap = textStyle.getOverlap();
        this.textState_ = {
            font: textFont !== undefined ?
                textFont : ol.render.canvas.defaultFont,
            textAlign: textTextAlign !== undefined ?
                textTextAlign : ol.render.canvas.defaultTextAlign,
            textBaseline: textTextBaseline !== undefined ?
                textTextBaseline : ol.render.canvas.defaultTextBaseline
        };
        this.text_ = textText !== undefined ? textText : '';
        this.textOffsetX_ =
            textOffsetX !== undefined ? (this.pixelRatio_ * textOffsetX) : 0;
        this.textOffsetY_ =
            textOffsetY !== undefined ? (this.pixelRatio_ * textOffsetY) : 0;
        this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
        this.textRotation_ = textRotation !== undefined ? textRotation : 0;
        this.textScale_ = this.pixelRatio_ * (textScale !== undefined ?
            textScale : 1);
        // VFL свойсто перекрытия. В мапнике по умолчанию false, тут true, т.к. в проектах по умолчанию объекты перекрываются
        this.textOverlap_ = textOverlap !== undefined ? textOverlap : true;
    }
};
// VFL запуск рендера детектора фичи по координате (не визуальный рендер, но рабатает по такому же принципу)
// очистка накопителя пересечений для рендера детектора, прокидывние слоя
ol.renderer.Map.prototype.forEachFeatureAtCoordinate = function (
    coordinate,
    frameState,
    hitTolerance,
    callback,
    thisArg,
    layerFilter,
    thisArg2
) {
    var result;
    var viewState = frameState.viewState;
    var viewResolution = viewState.resolution;

    /**
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {import("../layer/Layer.js").default} layer Layer.
     * @return {?} Callback result.
     */
    function forEachFeatureAtCoordinate(feature, layer) {
        var managed = frameState.layerStates[ol.getUid(layer)].managed;
        if (!(ol.getUid(feature) in frameState.skippedFeatureUids && !managed)) {
            return callback.call(thisArg, feature, managed ? layer : null);
        }
    }

    var projection = viewState.projection;

    var translatedCoordinate = coordinate;
    if (projection.canWrapX()) {
        var projectionExtent = projection.getExtent();
        var worldWidth = ol.extent.getWidth(projectionExtent);
        var x = coordinate[0];
        if (x < projectionExtent[0] || x > projectionExtent[2]) {
            var worldsAway = Math.ceil((projectionExtent[0] - x) / worldWidth);
            translatedCoordinate = [x + worldWidth * worldsAway, coordinate[1]];
        }
    }

    var layerStates = frameState.layerStatesArray;
    var numLayers = layerStates.length;
    var i;
    for (i = numLayers - 1; i >= 0; --i) {
        var layerState = layerStates[i];
        var layer = layerState.layer;
        if (layer.get('overlapHitDetector')) {
            // VFL очистка накопителя пересечений
            layer.get('overlapHitDetector').clear();
        }
        if (ol.layer.Layer.visibleAtResolution(layerState, viewResolution) && layerFilter.call(thisArg2, layer)) {
            var layerRenderer = this.getLayerRenderer(layer);
            var source = /** @type {import("../layer/Layer.js").default} */ (layer).getSource();
            if (source) {
                result = layerRenderer.forEachFeatureAtCoordinate(
                    source.getWrapX() ? translatedCoordinate : coordinate,
                    frameState, hitTolerance, forEachFeatureAtCoordinate, undefined, layer);
            }
            if (result) {
                return result;
            }
        }
    }
    return undefined;
};

// VFL ещё прокидывание layer
ol.renderer.canvas.VectorLayer.prototype.forEachFeatureAtCoordinate = function forEachFeatureAtCoordinate (coordinate, frameState, hitTolerance, callback, thisArg) {
    if (!this.replayGroup_) {
        return undefined;
    } else {
        var resolution = frameState.viewState.resolution;
        var rotation = frameState.viewState.rotation;
        var layer = /** @type {import("../../layer/Vector.js").default} */ (this.getLayer());
        /** @type {!Object<string, boolean>} */
        var features = {};
        var result = this.replayGroup_.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, {},
            /**
             * @param {import("../../Feature.js").FeatureLike} feature Feature.
             * @return {?} Callback result.
             */
            function(feature) {
                var key = ol.getUid(feature);
                if (!(key in features)) {
                    features[key] = true;
                    return callback.call(thisArg, feature, layer);
                }
            }, null, layer);
        return result;
    }
};

// VFL ещё прокидывени layer и очистка геомтерий, честный вектор
ol.renderer.canvas.VectorLayer.prototype.compose = function (context, frameState, layerState) {
    var extent = frameState.extent;
    var pixelRatio = frameState.pixelRatio;
    var skippedFeatureUids = layerState.managed ?
        frameState.skippedFeatureUids : {};
    var viewState = frameState.viewState;
    var projection = viewState.projection;
    var rotation = viewState.rotation;
    var projectionExtent = projection.getExtent();
    var vectorSource = /** @type {import("../../source/Vector.js").default} */ (this.getLayer().getSource());

    var transform = this.getTransform(frameState, 0);

    // clipped rendering if layer extent is set
    var clipExtent = layerState.extent;
    var clipped = clipExtent !== undefined;
    if (clipped) {
        this.clip(context, frameState, /** @type {import("../../extent.js").Extent} */ (clipExtent));
    }
    var replayGroup = this.replayGroup_;
    if (replayGroup && !replayGroup.isEmpty()) {
        if (this.declutterTree_) {
            this.declutterTree_.clear();
        }
        var layer = /** @type {import("../../layer/Vector.js").default} */ (this.getLayer());
        var drawOffsetX = 0;
        var drawOffsetY = 0;
        var replayContext;
        var transparentLayer = layerState.opacity !== 1;
        var hasRenderListeners = layer.hasListener(ol.render.EventType.RENDER);
        if (transparentLayer || hasRenderListeners) {
            var drawWidth = context.canvas.width;
            var drawHeight = context.canvas.height;
            if (rotation) {
                var drawSize = Math.round(Math.sqrt(drawWidth * drawWidth + drawHeight * drawHeight));
                drawOffsetX = (drawSize - drawWidth) / 2;
                drawOffsetY = (drawSize - drawHeight) / 2;
                drawWidth = drawHeight = drawSize;
            }
            // resize and clear
            this.context.canvas.width = drawWidth;
            this.context.canvas.height = drawHeight;
            replayContext = this.context;
        } else {
            replayContext = context;
        }

        var alpha = replayContext.globalAlpha;
        if (!transparentLayer) {
            // for performance reasons, context.save / context.restore is not used
            // to save and restore the transformation matrix and the opacity.
            // see http://jsperf.com/context-save-restore-versus-variable
            replayContext.globalAlpha = layerState.opacity;
        }

        if (replayContext != context) {
            replayContext.translate(drawOffsetX, drawOffsetY);
        }

        var viewHints = frameState.viewHints;
        var snapToPixel = !(viewHints[ol.ViewHint.ANIMATING] || viewHints[ol.ViewHint.INTERACTING]);
        var width = frameState.size[0] * pixelRatio;
        var height = frameState.size[1] * pixelRatio;
        ol.render.canvas.rotateAtOffset(replayContext, -rotation,
            width / 2, height / 2);

        // VFL для визуального рендера: детектор пересечений и накопители bbox стилей
        // + разеделение на визуально отображаемые и скрытые
        // вызывается тут, потому что это место определения, что image слоя необходимо перерисовать
        if (!layer.get('overlapDetector')) {
            layer.set('overlapDetector', new ol.rbush(), true);
        }
        if (!layer.get('overlapHitDetector')) {
            layer.set('overlapHitDetector', new ol.rbush(), true);
        }
        layer.get('overlapDetector').clear();
        layer.set('overlapFeatureExtents', {}, true);
        layer.set('overlapFeatureExtentsShown', {}, true);
        layer.set('overlapFeatureExtentsHidden', {}, true);

        replayGroup.replay(replayContext, transform, rotation, skippedFeatureUids, snapToPixel, undefined, null, layer);
        if (vectorSource.getWrapX() && projection.canWrapX() &&
            !ol.extent.containsExtent(projectionExtent, extent)) {
            var startX = extent[0];
            var worldWidth = ol.extent.getWidth(projectionExtent);
            var world = 0;
            var offsetX;
            while (startX < projectionExtent[0]) {
                --world;
                offsetX = worldWidth * world;
                transform = this.getTransform(frameState, offsetX);
                replayGroup.replay(replayContext, transform, rotation, skippedFeatureUids, snapToPixel, undefined, null, layer);
                startX += worldWidth;
            }
            world = 0;
            startX = extent[2];
            while (startX > projectionExtent[2]) {
                ++world;
                offsetX = worldWidth * world;
                transform = this.getTransform(frameState, offsetX);
                replayGroup.replay(replayContext, transform, rotation, skippedFeatureUids, snapToPixel, undefined, null, layer);
                startX -= worldWidth;
            }
        }
        ol.render.canvas.rotateAtOffset(replayContext, rotation,
            width / 2, height / 2);

        if (hasRenderListeners) {
            this.dispatchRenderEvent(replayContext, frameState, transform);
        }
        if (replayContext != context) {
            if (transparentLayer) {
                var mainContextAlpha = context.globalAlpha;
                context.globalAlpha = layerState.opacity;
                context.drawImage(replayContext.canvas, -drawOffsetX, -drawOffsetY);
                context.globalAlpha = mainContextAlpha;
            } else {
                context.drawImage(replayContext.canvas, -drawOffsetX, -drawOffsetY);
            }
            replayContext.translate(-drawOffsetX, -drawOffsetY);
        }

        if (!transparentLayer) {
            replayContext.globalAlpha = alpha;
        }
    }

    if (clipped) {
        context.restore();
    }
};

// VFL прокидывание layer в детектор
ol.render.canvas.ReplayGroup.prototype.forEachFeatureAtCoordinate = function (
    coordinate,
    resolution,
    rotation,
    hitTolerance,
    skippedFeaturesHash,
    callback,
    declutterReplays,
    layer
) {

    hitTolerance = Math.round(hitTolerance);
    var contextSize = hitTolerance * 2 + 1;
    var transform = ol.transform.compose(this.hitDetectionTransform_,
        hitTolerance + 0.5, hitTolerance + 0.5,
        1 / resolution, -1 / resolution,
        -rotation,
        -coordinate[0], -coordinate[1]);
    var context = this.hitDetectionContext_;

    if (context.canvas.width !== contextSize || context.canvas.height !== contextSize) {
        context.canvas.width = contextSize;
        context.canvas.height = contextSize;
    } else {
        context.clearRect(0, 0, contextSize, contextSize);
    }

    /**
     * @type {import("../../extent.js").Extent}
     */
    var hitExtent;
    if (this.renderBuffer_ !== undefined) {
        hitExtent = ol.extent.createEmpty();
        ol.extent.extendCoordinate(hitExtent, coordinate);
        ol.extent.buffer(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
    }

    var mask = ol.render.canvas.ReplayGroup.getCircleArray(hitTolerance);
    var declutteredFeatures;
    if (this.declutterTree_) {
        declutteredFeatures = this.declutterTree_.all().map(function(entry) {
            return entry.value;
        });
    }

    var replayType;

    /**
     * @param {import("../../Feature.js").default|import("../Feature.js").default} feature Feature.
     * @return {?} Callback result.
     */
    function featureCallback(feature) {
        var imageData = context.getImageData(0, 0, contextSize, contextSize).data;
        for (var i = 0; i < contextSize; i++) {
            for (var j = 0; j < contextSize; j++) {
                if (mask[i][j]) {
                    if (imageData[(j * contextSize + i) * 4 + 3] > 0) {
                        var result = (void 0);
                        if (!(declutteredFeatures && (replayType == ol.render.ReplayType.IMAGE || replayType == ol.render.ReplayType.TEXT)) ||
                            declutteredFeatures.indexOf(feature) !== -1) {
                            result = callback(feature);
                        }
                        if (result) {
                            return result;
                        } else {
                            context.clearRect(0, 0, contextSize, contextSize);
                            return undefined;
                        }
                    }
                }
            }
        }
    }

    /** @type {Array<number>} */
    var zs = Object.keys(this.replaysByZIndex_).map(Number);
    zs.sort(ol.array.numberSafeCompareFunction);

    var i, j, replays, replay, result;
    for (i = zs.length - 1; i >= 0; --i) {
        var zIndexKey = zs[i].toString();
        replays = this.replaysByZIndex_[zIndexKey];
        for (j = ol.render.ORDER.length - 1; j >= 0; --j) {
            replayType = ol.render.ORDER[j];
            replay = replays[replayType];
            if (replay !== undefined) {
                if (declutterReplays &&
                    (replayType == ol.render.ReplayType.IMAGE || replayType == ol.render.ReplayType.TEXT)) {
                    var declutter = declutterReplays[zIndexKey];
                    if (!declutter) {
                        declutterReplays[zIndexKey] = [replay, transform.slice(0)];
                    } else {
                        declutter.push(replay, transform.slice(0));
                    }
                } else {
                    result = replay.replayHitDetection(context, transform, rotation,
                        skippedFeaturesHash, featureCallback, hitExtent, layer);
                    if (result) {
                        return result;
                    }
                }
            }
        }
    }
    return undefined;
};

// VFL прокидывние layer в отприсовку
ol.render.canvas.ReplayGroup.prototype.replay = function (
    context,
    transform,
    viewRotation,
    skippedFeaturesHash,
    snapToPixel,
    opt_replayTypes,
    opt_declutterReplays,
    layer
) {

    /** @type {Array<number>} */
    var zs = Object.keys(this.replaysByZIndex_).map(Number);
    zs.sort(ol.array.numberSafeCompareFunction);

    // setup clipping so that the parts of over-simplified geometries are not
    // visible outside the current extent when panning
    context.save();
    // без обрезки для отображения данных за переделами области отрисовки, важно для векторных тайлов
    // this.clip(context, transform);

    var replayTypes = opt_replayTypes ? opt_replayTypes : ol.render.ORDER;
    var i, ii, j, jj, replays, replay;
    for (i = 0, ii = zs.length; i < ii; ++i) {
        var zIndexKey = zs[i].toString();
        replays = this.replaysByZIndex_[zIndexKey];
        for (j = 0, jj = replayTypes.length; j < jj; ++j) {
            var replayType = replayTypes[j];
            replay = replays[replayType];
            if (replay !== undefined) {
                if (opt_declutterReplays &&
                    (replayType == ol.render.ReplayType.IMAGE || replayType == ol.render.ReplayType.TEXT)) {
                    var declutter = opt_declutterReplays[zIndexKey];
                    if (!declutter) {
                        opt_declutterReplays[zIndexKey] = [replay, transform.slice(0)];
                    } else {
                        declutter.push(replay, transform.slice(0));
                    }
                } else {
                    replay.replay(context, transform, viewRotation, skippedFeaturesHash, snapToPixel, layer);
                }
            }
        }
    }

    context.restore();
};

// VFL прокидывание layer в детектор
ol.render.canvas.Replay.prototype.replayHitDetection = function (
    context,
    transform,
    viewRotation,
    skippedFeaturesHash,
    opt_featureCallback,
    opt_hitExtent,
    layer
) {
    this.viewRotation_ = viewRotation;
    return this.replay_(context, transform, skippedFeaturesHash,
        this.hitDetectionInstructions, true, opt_featureCallback, opt_hitExtent, layer);
};

// VFL прокидывние слоя в отрисовку
ol.render.canvas.Replay.prototype.replay = function (
    context, transform, viewRotation, skippedFeaturesHash, snapToPixel, layer) {
    this.viewRotation_ = viewRotation;
    this.replay_(context, transform,
        skippedFeaturesHash, this.instructions, snapToPixel, undefined, undefined, layer);
};

// VFL собстенно рендер в canvas, самая важная часть
// при визуальном рендере накапливаются геометрии, просчитываются пересечения
// при рендере детектора проверяются накопленные геометрии, в т.ч. по стилям
// можно увидеть пересечения при window.showOverlap = true
// активно используется преобразование координат, т.к. canvas при детекторе приходит размером 1х1 пикс и координаты отличаются
// от координат при визуальном рендере, а после преобразований - корректный 3857
// ВАЖНО! сейчас при сохранении геометрии отображенных/скрытых стилей производится округление до целых
// т.к. при преобразовании координат происходят потери в точности
// возможно стоит брать большую точность (степень двойки)
ol.render.canvas.Replay.prototype.replay_ = function (
    context,
    transform,
    skippedFeaturesHash,
    instructions,
    snapToPixel,
    featureCallback,
    opt_hitExtent,
    // VFL прокинут слой
    layer
) {
    if (ol.OMS_VECTOR_ALLOW_OVERLAP) {
        /** @type {Array<number>} */
        var pixelCoordinates;
        if (this.pixelCoordinates_ && ol.array.equals(transform, this.renderedTransform_)) {
            pixelCoordinates = this.pixelCoordinates_;
        } else {
            if (!this.pixelCoordinates_) {
                this.pixelCoordinates_ = [];
            }
            pixelCoordinates = ol.geom.flat.transform.transform2D(
                this.coordinates, 0, this.coordinates.length, 2,
                transform, this.pixelCoordinates_);
            ol.transform.setFromArray(this.renderedTransform_, transform);
        }
        // VFL матрица обратной трансформации координат
        // отдельная переменная, т.к. преобразование влияет переданную в метод матрицу
        var transformInverted = [];
        for (var _idx = 0; _idx < transform.length; _idx++) {
            transformInverted.push(transform[_idx]);
        }
        transformInverted = ol.transform.invert(transformInverted);
        var skipFeatures = !ol.obj.isEmpty(skippedFeaturesHash);
        var i = 0; // instruction index
        var ii = instructions.length; // end of instructions
        var d = 0; // data index
        var dd; // end of per-instruction data
        var anchorX, anchorY, prevX, prevY, roundX, roundY, declutterGroup, image;
        var pendingFill = 0;
        var pendingStroke = 0;
        var lastFillInstruction = null;
        var lastStrokeInstruction = null;
        var coordinateCache = this.coordinateCache_;
        var viewRotation = this.viewRotation_;

        var state = /** @type {import("../../render.js").State} */ ({
            context: context,
            pixelRatio: this.pixelRatio,
            resolution: this.resolution,
            rotation: viewRotation
        });

        // When the batch size gets too big, performance decreases. 200 is a good
        // balance between batch size and number of fill/stroke instructions.
        var batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
        var /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ feature;
        var x, y;
        // VFL текущий накопитель коллизий в зависимости от типа рендера (визуальный/детектор)
        // возможно накопитель детектора больше не нужен, т.к. для определения отрисовки в детекторе используется геометрия стиля
        var overlapDetector;
        if (opt_hitExtent === undefined) {
            if (layer !== undefined && layer.get('overlapDetector')) {
                overlapDetector = layer.get('overlapDetector');
            }
        } else {
            if (layer !== undefined && layer.get('overlapHitDetector')) {
                overlapDetector = layer.get('overlapHitDetector');
            }
        }
        // VFL идентфиикатор текущей фичи
        // любая инструкция, отвечающая за рисование на canvas имеет пункт BEGIN_GEOMETRY и END_GEOMETRY
        // причем BEGIN_GEOMETRY всегда ПЕРЕД инструкцие изменения пикселей canvas,
        // т.е. при BEGIN_GEOMTRY возможно достоверно сзапомнить id фичи, стили которой будет отрисованы в процессе исполнения инструкций
        var currenFeatureId;
        // VFL определение попадания фичи в текущий bbox отрисовки (у детектора он не равен bbox видимой области карты)
        // помимо проверки попадания геометрии фичи, проверяет попадаение геометрии видимых стилей фич
        var detectStyleIntersects = function (extent, featureExtent, styleExtents) {
            var i;
            if (ol.extent.intersects(extent, featureExtent)) {
                return true;
            }
            for (i = 0; i < styleExtents.length; i++) {
                if (ol.extent.intersects(extent, styleExtents[i])) {
                    return true;
                }
            }
            return false;
        };
        // VFL добавление геометрии видимого стиля
        // тут используется не полноценный bbox, а ключ по нему, для ускорения
        var addShownExtent = function (featureId, resolution, extent) {
            if (layer === undefined || !layer.get('overlapFeatureExtentsShown')) {
                return;
            }
            var extentRound = [Math.round(extent[0]), Math.round(extent[1]), Math.round(extent[2]), Math.round(extent[3])];
            var extentKey = extentRound.join(':');
            var overlapFeatureExtentsShown = layer.get('overlapFeatureExtentsShown');
            if (!overlapFeatureExtentsShown[featureId]) {
                overlapFeatureExtentsShown[featureId] = {};
            }
            if (!overlapFeatureExtentsShown[featureId][resolution]) {
                overlapFeatureExtentsShown[featureId][resolution] = {};
            }
            overlapFeatureExtentsShown[featureId][resolution][extentKey] = true;
        };
        // VFL добпвление геомтерии скрытого стиля
        // тут используется не полноценный bbox, а ключ по нему, для ускорения
        var addHiddenExtent = function (featureId, resolution, extent) {
            if (layer === undefined || !layer.get('overlapFeatureExtentsHidden')) {
                return;
            }
            var extentRound = [Math.round(extent[0]), Math.round(extent[1]), Math.round(extent[2]), Math.round(extent[3])];
            var extentKey = extentRound.join(':');
            var overlapFeatureExtentsHidden = layer.get('overlapFeatureExtentsHidden');
            if (!overlapFeatureExtentsHidden[featureId]) {
                overlapFeatureExtentsHidden[featureId] = {};
            }
            if (!overlapFeatureExtentsHidden[featureId][resolution]) {
                overlapFeatureExtentsHidden[featureId][resolution] = {};
            }
            overlapFeatureExtentsHidden[featureId][resolution][extentKey] = true;
        };
        // VFL проверка на наличие отображенного стиля по его геометрии
        var isShownExtent = function (featureId, resolution, extent) {
            if (layer === undefined || !layer.get('overlapFeatureExtentsShown')) {
                return true;
            }
            var extentRound = [Math.round(extent[0]), Math.round(extent[1]), Math.round(extent[2]), Math.round(extent[3])];
            var extentKey = extentRound.join(':');
            var overlapFeatureExtentsShown = layer.get('overlapFeatureExtentsShown');
            return !!overlapFeatureExtentsShown[featureId] && !!overlapFeatureExtentsShown[featureId][resolution] && !!overlapFeatureExtentsShown[featureId][resolution][extentKey];
        };
        // проврека на наличие скрытого стиял по его геометрии
        var isHiddenExtent = function (featureId, resolution, extent) {
            if (layer === undefined || !layer.get('overlapFeatureExtentsHidden')) {
                return false;
            }
            var extentRound = [Math.round(extent[0]), Math.round(extent[1]), Math.round(extent[2]), Math.round(extent[3])];
            var extentKey = extentRound.join(':');
            var overlapFeatureExtentsHidden = layer.get('overlapFeatureExtentsHidden');
            return !!overlapFeatureExtentsHidden[featureId] && !!overlapFeatureExtentsHidden[featureId][resolution] && !!overlapFeatureExtentsHidden[featureId][resolution][extentKey];
        };
        while (i < ii) {
            var instruction = instructions[i];
            var type = /** @type {CanvasInstruction} */ (instruction[0]);
            // VFL атрибут допустимости перекрытия стиля (пока что текста)
            var overlap;
            switch (type) {
                case ol.render.canvas.Instruction.BEGIN_GEOMETRY:
                    feature = /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ (instruction[1]);
                    // VFL запомнить id фичи и проинициализировать накопитель геометри видимых стилей фичи
                    currenFeatureId = ol.getUid(feature);
                    if (opt_hitExtent === undefined && layer !== undefined && layer.get('overlapFeatureExtents')) {
                        if (!layer.get('overlapFeatureExtents')[currenFeatureId]) {
                            layer.get('overlapFeatureExtents')[currenFeatureId] = {};
                        }
                        if (!layer.get('overlapFeatureExtents')[currenFeatureId][this.resolution]) {
                            layer.get('overlapFeatureExtents')[currenFeatureId][this.resolution] = [];
                        }
                    }
                    if ((skipFeatures && skippedFeaturesHash[ol.getUid(feature)]) || !feature.getGeometry()) {
                        i = /** @type {number} */ (instruction[2]);
                        // } else if (opt_hitExtent !== undefined && !ol.extent.intersects(
                        //     opt_hitExtent, feature.getGeometry().getExtent())) {
                        //     i = /** @type {number} */ (instruction[2]) + 1;
                        // VFL вместо проверки пересечения ТОЛЬКО по геометрии теперь проверка и по геометрии стилей
                    } else if (opt_hitExtent !== undefined && !detectStyleIntersects(opt_hitExtent, feature.getGeometry().getExtent(), layer !== undefined && layer.get('overlapFeatureExtents') ? layer.get('overlapFeatureExtents')[currenFeatureId][this.resolution] : [])) {
                        i = /** @type {number} */ (instruction[2]) + 1;
                    } else {
                        ++i;
                    }
                    // VFL можно подебажить объекты найденных фич
                    if (window.showOverlap && opt_hitExtent !== undefined && detectStyleIntersects(opt_hitExtent, feature.getGeometry().getExtent(), layer !== undefined && layer.get('overlapFeatureExtents') ? layer.get('overlapFeatureExtents')[currenFeatureId][this.resolution] : [])) {
                        console.log(feature);
                    }
                    break;
                case ol.render.canvas.Instruction.BEGIN_PATH:
                    if (pendingFill > batchSize) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke > batchSize) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    if (!pendingFill && !pendingStroke) {
                        context.beginPath();
                        prevX = prevY = NaN;
                    }
                    ++i;
                    break;
                case ol.render.canvas.Instruction.CIRCLE:
                    d = /** @type {number} */ (instruction[1]);
                    var x1 = pixelCoordinates[d];
                    var y1 = pixelCoordinates[d + 1];
                    var x2 = pixelCoordinates[d + 2];
                    var y2 = pixelCoordinates[d + 3];
                    var dx = x2 - x1;
                    var dy = y2 - y1;
                    var r = Math.sqrt(dx * dx + dy * dy);
                    context.moveTo(x1 + r, y1);
                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
                    ++i;
                    break;
                case ol.render.canvas.Instruction.CLOSE_PATH:
                    context.closePath();
                    ++i;
                    break;
                case ol.render.canvas.Instruction.CUSTOM:
                    d = /** @type {number} */ (instruction[1]);
                    dd = instruction[2];
                    var geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ (instruction[3]);
                    var renderer = instruction[4];
                    var fn = instruction.length == 6 ? instruction[5] : undefined;
                    state.geometry = geometry;
                    state.feature = feature;
                    if (!(i in coordinateCache)) {
                        coordinateCache[i] = [];
                    }
                    var coords = coordinateCache[i];
                    if (fn) {
                        fn(pixelCoordinates, d, dd, 2, coords);
                    } else {
                        coords[0] = pixelCoordinates[d];
                        coords[1] = pixelCoordinates[d + 1];
                        coords.length = 2;
                    }
                    renderer(coords, state);
                    ++i;
                    break;
                case ol.render.canvas.Instruction.DRAW_IMAGE:
                    d = /** @type {number} */ (instruction[1]);
                    dd = /** @type {number} */ (instruction[2]);
                    image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */
                        (instruction[3]);
                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
                    anchorX = /** @type {number} */ (instruction[4]);
                    anchorY = /** @type {number} */ (instruction[5]);
                    declutterGroup = featureCallback ? null : /** @type {import("../canvas.js").DeclutterGroup} */ (instruction[6]);
                    var height = /** @type {number} */ (instruction[7]);
                    var opacity = /** @type {number} */ (instruction[8]);
                    var originX = /** @type {number} */ (instruction[9]);
                    var originY = /** @type {number} */ (instruction[10]);
                    var rotateWithView = /** @type {boolean} */ (instruction[11]);
                    var rotation = /** @type {number} */ (instruction[12]);
                    var scale$$1 = /** @type {number} */ (instruction[13]);
                    var width = /** @type {number} */ (instruction[14]);

                    var padding = (void 0), backgroundFill = (void 0), backgroundStroke = (void 0);
                    // VFL - если это текст, то инструкций у него > 16 (исходя из ImageReply и TextReply)
                    if (instruction.length > 16) {
                        padding = /** @type {Array<number>} */ (instruction[15]);
                        backgroundFill = /** @type {boolean} */ (instruction[16]);
                        backgroundStroke = /** @type {boolean} */ (instruction[17]);
                    } else {
                        padding = ol.render.canvas.defaultPadding;
                        backgroundFill = backgroundStroke = false;
                    }
                    // VFL перекрытие по умолчанию есть. Типа глобальное решение, можно и для остальных типов отрисовки,
                    // помимо текста, добавлять подобный флаг, только учитывать индекс инструкции
                    overlap = instruction[18] !== undefined ? instruction[18] : true;

                    if (rotateWithView) {
                        rotation += viewRotation;
                    }
                    for (; d < dd; d += 2) {
                        // VFL расчет перекрытий и их учет
                        // итого - нужно ли рисовать объект
                        var objShown = false;
                        var collides = false;
                        // дублирование глубоко спрятанной логики расчета ширины, высоты и позиции
                        var xo = pixelCoordinates[d] - anchorX * scale$$1,
                            yo = pixelCoordinates[d + 1] - anchorY * scale$$1,
                            wo = (width + originX > image.width) ? image.width - originX : width,
                            ho = (height + originY > image.height) ? image.height - originY : height;
                        // габариты текущего объекта отрисовки
                        var r = {
                            minX: xo, minY: yo,
                            maxX: xo + wo * scale$$1, maxY: yo + ho * scale$$1
                        };
                        // проверка на перекрытие только для объектов, которые могут быть вытолкнуты
                        if (!overlap) {
                            collides = overlapDetector ? overlapDetector.collides(r) : false;
                        }
                        // для дальнейших расчетов не учитываются вытолкнутые объекты, т.к. они не будут отрисованы
                        if (!collides && overlapDetector) {
                            overlapDetector.insert(r);
                        }
                        // VFL можно подебажить геометрию в т.ч. для вытолкнутых объектов
                        if (window.showOverlap) {
                            var tmp1 = context.strokeStyle;
                            var tmp2 = context.lineWidth;

                            // context.lineWidth = 1;
                            context.lineWidth = 1;
                            context.strokeStyle = collides ? 'red' : 'green';

                            context.strokeRect(xo, yo, wo * scale$$1, ho * scale$$1);

                            context.strokeStyle = tmp1;
                            context.lineWidth = tmp2
                        }
                        // рассовать габариты
                        // в режиме визуальнго рендера - записать габарит объекта (видимого и невидимого)
                        if (opt_hitExtent === undefined) {
                            if (!collides) {
                                if (layer !== undefined && layer.get('overlapFeatureExtents')) {
                                    layer.get('overlapFeatureExtents')[currenFeatureId][this.resolution].push(ol.geom.flat.transform.transform2D(
                                        [r.minX, r.maxY, r.maxX, r.minY], 0, 4, 2, transformInverted
                                    ));
                                }
                                addShownExtent(currenFeatureId, this.resolution, ol.geom.flat.transform.transform2D(
                                    [r.minX, r.maxY, r.maxX, r.minY], 0, 4, 2, transformInverted
                                ));
                            } else {
                                addHiddenExtent(currenFeatureId, this.resolution, ol.geom.flat.transform.transform2D(
                                    [r.minX, r.maxY, r.maxX, r.minY], 0, 4, 2, transformInverted
                                ));
                            }
                        }
                        // TODO упростить
                        // VFL если пересчения нет, то можно нарисовать объект
                        // ВАЖНО! в режиме детектора проверяет не просто наличие пересечения (оно посчти всегда некорректное
                        // из за ограниченного bbox) но и ранее накопленные данные об отображенности/скрытости стилей по геометриям
                        if (!collides) {

                            // VFL при отсутствии коллизий отображаем объект,
                            // если он может пересекаться
                            // или это визуальные рендер
                            // или это рендер детектор и геометрия есть в отображенных и нет в скрытых
                            if (overlap || opt_hitExtent === undefined ||
                                (opt_hitExtent !== undefined &&
                                    isShownExtent(currenFeatureId, this.resolution, ol.geom.flat.transform.transform2D(
                                        [r.minX, r.maxY, r.maxX, r.minY], 0, 4, 2, transformInverted
                                    )) && !isHiddenExtent(currenFeatureId, this.resolution, ol.geom.flat.transform.transform2D(
                                        [r.minX, r.maxY, r.maxX, r.minY], 0, 4, 2, transformInverted
                                    )))
                            ) {
                                objShown = true;
                            }
                        } else if (!overlap && opt_hitExtent !== undefined) {
                            // VFL есть коллизия и объект не может пересекаться и режим детектора
                            // то необходимо проверить, может в режиме визуального рендера он был отрисован
                            if (
                                isShownExtent(currenFeatureId, this.resolution, ol.geom.flat.transform.transform2D(
                                    [r.minX, r.maxY, r.maxX, r.minY], 0, 4, 2, transformInverted
                                )) && !isHiddenExtent(currenFeatureId, this.resolution, ol.geom.flat.transform.transform2D(
                                [r.minX, r.maxY, r.maxX, r.minY], 0, 4, 2, transformInverted
                                ))
                            ) {
                                objShown = true;
                            }
                        }
                        if (objShown) {
                            this.replayImage_(context,
                                pixelCoordinates[d], pixelCoordinates[d + 1], image, anchorX, anchorY,
                                declutterGroup, height, opacity, originX, originY, rotation, scale$$1,
                                snapToPixel, width, padding,
                                backgroundFill ? /** @type {Array<*>} */ (lastFillInstruction) : null,
                                backgroundStroke ? /** @type {Array<*>} */ (lastStrokeInstruction) : null);
                        }
                    }
                    this.renderDeclutter_(declutterGroup, feature);
                    ++i;
                    break;
                case ol.render.canvas.Instruction.DRAW_CHARS:
                    var begin = /** @type {number} */ (instruction[1]);
                    var end = /** @type {number} */ (instruction[2]);
                    var baseline = /** @type {number} */ (instruction[3]);
                    declutterGroup = featureCallback ? null : /** @type {import("../canvas.js").DeclutterGroup} */ (instruction[4]);
                    var overflow = /** @type {number} */ (instruction[5]);
                    var fillKey = /** @type {string} */ (instruction[6]);
                    var maxAngle = /** @type {number} */ (instruction[7]);
                    var measure = /** @type {function(string):number} */ (instruction[8]);
                    var offsetY = /** @type {number} */ (instruction[9]);
                    var strokeKey = /** @type {string} */ (instruction[10]);
                    var strokeWidth = /** @type {number} */ (instruction[11]);
                    var text = /** @type {string} */ (instruction[12]);
                    var textKey = /** @type {string} */ (instruction[13]);
                    var textScale = /** @type {number} */ (instruction[14]);

                    var pathLength = ol.geom.flat.length.lineStringLength(pixelCoordinates, begin, end, 2);
                    var textLength = measure(text);
                    if (overflow || textLength <= pathLength) {
                        /** @type {import("./TextReplay.js").default} */
                        var textReplay = /** @type {?} */ (this);
                        var textAlign = textReplay.textStates[textKey].textAlign;
                        var startM = (pathLength - textLength) * ol.render.TEXT_ALIGN[textAlign];
                        var parts = ol.geom.flat.textpath.drawTextOnPath(
                            pixelCoordinates, begin, end, 2, text, measure, startM, maxAngle);
                        if (parts) {
                            var c = (void 0), cc = (void 0), chars = (void 0), label = (void 0), part = (void 0);
                            if (strokeKey) {
                                for (c = 0, cc = parts.length; c < cc; ++c) {
                                    part = parts[c]; // x, y, anchorX, rotation, chunk
                                    chars = /** @type {string} */ (part[4]);
                                    label = textReplay.getImage(chars, textKey, '', strokeKey);
                                    anchorX = /** @type {number} */ (part[2]) + strokeWidth;
                                    anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth - offsetY;
                                    this.replayImage_(context,
                                        /** @type {number} */ (part[0]), /** @type {number} */ (part[1]), label,
                                        anchorX, anchorY, declutterGroup, label.height, 1, 0, 0,
                                        /** @type {number} */ (part[3]), textScale, false, label.width,
                                        ol.render.canvas.defaultPadding, null, null);
                                }
                            }
                            if (fillKey) {
                                for (c = 0, cc = parts.length; c < cc; ++c) {
                                    part = parts[c]; // x, y, anchorX, rotation, chunk
                                    chars = /** @type {string} */ (part[4]);
                                    label = textReplay.getImage(chars, textKey, fillKey, '');
                                    anchorX = /** @type {number} */ (part[2]);
                                    anchorY = baseline * label.height - offsetY;
                                    this.replayImage_(context,
                                        /** @type {number} */ (part[0]), /** @type {number} */ (part[1]), label,
                                        anchorX, anchorY, declutterGroup, label.height, 1, 0, 0,
                                        /** @type {number} */ (part[3]), textScale, false, label.width,
                                        ol.render.canvas.defaultPadding, null, null);
                                }
                            }
                        }
                    }
                    this.renderDeclutter_(declutterGroup, feature);
                    ++i;
                    break;
                case ol.render.canvas.Instruction.END_GEOMETRY:
                    if (featureCallback !== undefined) {
                        feature = /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ (instruction[1]);
                        var result = featureCallback(feature);
                        if (result) {
                            return result;
                        }
                    }
                    ++i;
                    break;
                case ol.render.canvas.Instruction.FILL:
                    if (batchSize) {
                        pendingFill++;
                    } else {
                        this.fill_(context);
                    }
                    ++i;
                    break;
                case ol.render.canvas.Instruction.MOVE_TO_LINE_TO:
                    d = /** @type {number} */ (instruction[1]);
                    dd = /** @type {number} */ (instruction[2]);
                    x = pixelCoordinates[d];
                    y = pixelCoordinates[d + 1];
                    roundX = (x + 0.5) | 0;
                    roundY = (y + 0.5) | 0;
                    if (roundX !== prevX || roundY !== prevY) {
                        context.moveTo(x, y);
                        prevX = roundX;
                        prevY = roundY;
                    }
                    for (d += 2; d < dd; d += 2) {
                        x = pixelCoordinates[d];
                        y = pixelCoordinates[d + 1];
                        roundX = (x + 0.5) | 0;
                        roundY = (y + 0.5) | 0;
                        if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
                            context.lineTo(x, y);
                            prevX = roundX;
                            prevY = roundY;
                        }
                    }
                    ++i;
                    break;
                case ol.render.canvas.Instruction.SET_FILL_STYLE:
                    lastFillInstruction = instruction;
                    this.alignFill_ = instruction[2];

                    if (pendingFill) {
                        this.fill_(context);
                        pendingFill = 0;
                        if (pendingStroke) {
                            context.stroke();
                            pendingStroke = 0;
                        }
                    }

                    context.fillStyle = /** @type {import("../../colorlike.js").ColorLike} */ (instruction[1]);
                    ++i;
                    break;
                case ol.render.canvas.Instruction.SET_STROKE_STYLE:
                    lastStrokeInstruction = instruction;
                    if (pendingStroke) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    this.setStrokeStyle_(context, /** @type {Array<*>} */ (instruction));
                    ++i;
                    break;
                case ol.render.canvas.Instruction.STROKE:
                    if (batchSize) {
                        pendingStroke++;
                    } else {
                        context.stroke();
                    }
                    ++i;
                    break;
                default:
                    ++i; // consume the instruction anyway, to avoid an infinite loop
                    break;
            }
        }
    } else {
        /** @type {Array<number>} */
        var pixelCoordinates;
        if (this.pixelCoordinates_ && ol.array.equals(transform, this.renderedTransform_)) {
            pixelCoordinates = this.pixelCoordinates_;
        } else {
            if (!this.pixelCoordinates_) {
                this.pixelCoordinates_ = [];
            }
            pixelCoordinates = ol.geom.flat.transform.transform2D(
                this.coordinates, 0, this.coordinates.length, 2,
                transform, this.pixelCoordinates_);
            ol.transform.setFromArray(this.renderedTransform_, transform);
        }
        var skipFeatures = !ol.obj.isEmpty(skippedFeaturesHash);
        var i = 0; // instruction index
        var ii = instructions.length; // end of instructions
        var d = 0; // data index
        var dd; // end of per-instruction data
        var anchorX, anchorY, prevX, prevY, roundX, roundY, declutterGroup, image;
        var pendingFill = 0;
        var pendingStroke = 0;
        var lastFillInstruction = null;
        var lastStrokeInstruction = null;
        var coordinateCache = this.coordinateCache_;
        var viewRotation = this.viewRotation_;

        var state = /** @type {import("../../render.js").State} */ ({
            context: context,
            pixelRatio: this.pixelRatio,
            resolution: this.resolution,
            rotation: viewRotation
        });

        // When the batch size gets too big, performance decreases. 200 is a good
        // balance between batch size and number of fill/stroke instructions.
        var batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
        var /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ feature;
        var x, y;
        while (i < ii) {
            var instruction = instructions[i];
            var type = /** @type {CanvasInstruction} */ (instruction[0]);
            switch (type) {
                case ol.render.canvas.Instruction.BEGIN_GEOMETRY:
                    feature = /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ (instruction[1]);
                    if ((skipFeatures && skippedFeaturesHash[ol.getUid(feature)]) || !feature.getGeometry()) {
                        i = /** @type {number} */ (instruction[2]);
                    } else if (opt_hitExtent !== undefined && !ol.extent.intersects(
                        opt_hitExtent, feature.getGeometry().getExtent())) {
                        i = /** @type {number} */ (instruction[2]) + 1;
                    } else {
                        ++i;
                    }
                    break;
                case ol.render.canvas.Instruction.BEGIN_PATH:
                    if (pendingFill > batchSize) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke > batchSize) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    if (!pendingFill && !pendingStroke) {
                        context.beginPath();
                        prevX = prevY = NaN;
                    }
                    ++i;
                    break;
                case ol.render.canvas.Instruction.CIRCLE:
                    d = /** @type {number} */ (instruction[1]);
                    var x1 = pixelCoordinates[d];
                    var y1 = pixelCoordinates[d + 1];
                    var x2 = pixelCoordinates[d + 2];
                    var y2 = pixelCoordinates[d + 3];
                    var dx = x2 - x1;
                    var dy = y2 - y1;
                    var r = Math.sqrt(dx * dx + dy * dy);
                    context.moveTo(x1 + r, y1);
                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
                    ++i;
                    break;
                case ol.render.canvas.Instruction.CLOSE_PATH:
                    context.closePath();
                    ++i;
                    break;
                case ol.render.canvas.Instruction.CUSTOM:
                    d = /** @type {number} */ (instruction[1]);
                    dd = instruction[2];
                    var geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ (instruction[3]);
                    var renderer = instruction[4];
                    var fn = instruction.length == 6 ? instruction[5] : undefined;
                    state.geometry = geometry;
                    state.feature = feature;
                    if (!(i in coordinateCache)) {
                        coordinateCache[i] = [];
                    }
                    var coords = coordinateCache[i];
                    if (fn) {
                        fn(pixelCoordinates, d, dd, 2, coords);
                    } else {
                        coords[0] = pixelCoordinates[d];
                        coords[1] = pixelCoordinates[d + 1];
                        coords.length = 2;
                    }
                    renderer(coords, state);
                    ++i;
                    break;
                case ol.render.canvas.Instruction.DRAW_IMAGE:
                    d = /** @type {number} */ (instruction[1]);
                    dd = /** @type {number} */ (instruction[2]);
                    image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */
                        (instruction[3]);
                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
                    anchorX = /** @type {number} */ (instruction[4]);
                    anchorY = /** @type {number} */ (instruction[5]);
                    declutterGroup = featureCallback ? null : /** @type {import("../canvas.js").DeclutterGroup} */ (instruction[6]);
                    var height = /** @type {number} */ (instruction[7]);
                    var opacity = /** @type {number} */ (instruction[8]);
                    var originX = /** @type {number} */ (instruction[9]);
                    var originY = /** @type {number} */ (instruction[10]);
                    var rotateWithView = /** @type {boolean} */ (instruction[11]);
                    var rotation = /** @type {number} */ (instruction[12]);
                    var scale$$1 = /** @type {number} */ (instruction[13]);
                    var width = /** @type {number} */ (instruction[14]);

                    var padding = (void 0), backgroundFill = (void 0), backgroundStroke = (void 0);
                    if (instruction.length > 16) {
                        padding = /** @type {Array<number>} */ (instruction[15]);
                        backgroundFill = /** @type {boolean} */ (instruction[16]);
                        backgroundStroke = /** @type {boolean} */ (instruction[17]);
                    } else {
                        padding = ol.render.canvas.defaultPadding;
                        backgroundFill = backgroundStroke = false;
                    }

                    if (rotateWithView) {
                        rotation += viewRotation;
                    }
                    for (; d < dd; d += 2) {
                        this.replayImage_(context,
                            pixelCoordinates[d], pixelCoordinates[d + 1], image, anchorX, anchorY,
                            declutterGroup, height, opacity, originX, originY, rotation, scale$$1,
                            snapToPixel, width, padding,
                            backgroundFill ? /** @type {Array<*>} */ (lastFillInstruction) : null,
                            backgroundStroke ? /** @type {Array<*>} */ (lastStrokeInstruction) : null);
                    }
                    this.renderDeclutter_(declutterGroup, feature);
                    ++i;
                    break;
                case ol.render.canvas.Instruction.DRAW_CHARS:
                    var begin = /** @type {number} */ (instruction[1]);
                    var end = /** @type {number} */ (instruction[2]);
                    var baseline = /** @type {number} */ (instruction[3]);
                    declutterGroup = featureCallback ? null : /** @type {import("../canvas.js").DeclutterGroup} */ (instruction[4]);
                    var overflow = /** @type {number} */ (instruction[5]);
                    var fillKey = /** @type {string} */ (instruction[6]);
                    var maxAngle = /** @type {number} */ (instruction[7]);
                    var measure = /** @type {function(string):number} */ (instruction[8]);
                    var offsetY = /** @type {number} */ (instruction[9]);
                    var strokeKey = /** @type {string} */ (instruction[10]);
                    var strokeWidth = /** @type {number} */ (instruction[11]);
                    var text = /** @type {string} */ (instruction[12]);
                    var textKey = /** @type {string} */ (instruction[13]);
                    var textScale = /** @type {number} */ (instruction[14]);

                    var pathLength = ol.geom.flat.length.lineStringLength(pixelCoordinates, begin, end, 2);
                    var textLength = measure(text);
                    if (overflow || textLength <= pathLength) {
                        /** @type {import("./TextReplay.js").default} */
                        var textReplay = /** @type {?} */ (this);
                        var textAlign = textReplay.textStates[textKey].textAlign;
                        var startM = (pathLength - textLength) * ol.render.TEXT_ALIGN[textAlign];
                        var parts = ol.geom.flat.textpath.drawTextOnPath(
                            pixelCoordinates, begin, end, 2, text, measure, startM, maxAngle);
                        if (parts) {
                            var c = (void 0), cc = (void 0), chars = (void 0), label = (void 0), part = (void 0);
                            if (strokeKey) {
                                for (c = 0, cc = parts.length; c < cc; ++c) {
                                    part = parts[c]; // x, y, anchorX, rotation, chunk
                                    chars = /** @type {string} */ (part[4]);
                                    label = textReplay.getImage(chars, textKey, '', strokeKey);
                                    anchorX = /** @type {number} */ (part[2]) + strokeWidth;
                                    anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth - offsetY;
                                    this.replayImage_(context,
                                        /** @type {number} */ (part[0]), /** @type {number} */ (part[1]), label,
                                        anchorX, anchorY, declutterGroup, label.height, 1, 0, 0,
                                        /** @type {number} */ (part[3]), textScale, false, label.width,
                                        ol.render.canvas.defaultPadding, null, null);
                                }
                            }
                            if (fillKey) {
                                for (c = 0, cc = parts.length; c < cc; ++c) {
                                    part = parts[c]; // x, y, anchorX, rotation, chunk
                                    chars = /** @type {string} */ (part[4]);
                                    label = textReplay.getImage(chars, textKey, fillKey, '');
                                    anchorX = /** @type {number} */ (part[2]);
                                    anchorY = baseline * label.height - offsetY;
                                    this.replayImage_(context,
                                        /** @type {number} */ (part[0]), /** @type {number} */ (part[1]), label,
                                        anchorX, anchorY, declutterGroup, label.height, 1, 0, 0,
                                        /** @type {number} */ (part[3]), textScale, false, label.width,
                                        ol.render.canvas.defaultPadding, null, null);
                                }
                            }
                        }
                    }
                    this.renderDeclutter_(declutterGroup, feature);
                    ++i;
                    break;
                case ol.render.canvas.Instruction.END_GEOMETRY:
                    if (featureCallback !== undefined) {
                        feature = /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ (instruction[1]);
                        var result = featureCallback(feature);
                        if (result) {
                            return result;
                        }
                    }
                    ++i;
                    break;
                case ol.render.canvas.Instruction.FILL:
                    if (batchSize) {
                        pendingFill++;
                    } else {
                        this.fill_(context);
                    }
                    ++i;
                    break;
                case ol.render.canvas.Instruction.MOVE_TO_LINE_TO:
                    d = /** @type {number} */ (instruction[1]);
                    dd = /** @type {number} */ (instruction[2]);
                    x = pixelCoordinates[d];
                    y = pixelCoordinates[d + 1];
                    roundX = (x + 0.5) | 0;
                    roundY = (y + 0.5) | 0;
                    if (roundX !== prevX || roundY !== prevY) {
                        context.moveTo(x, y);
                        prevX = roundX;
                        prevY = roundY;
                    }
                    for (d += 2; d < dd; d += 2) {
                        x = pixelCoordinates[d];
                        y = pixelCoordinates[d + 1];
                        roundX = (x + 0.5) | 0;
                        roundY = (y + 0.5) | 0;
                        if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
                            context.lineTo(x, y);
                            prevX = roundX;
                            prevY = roundY;
                        }
                    }
                    ++i;
                    break;
                case ol.render.canvas.Instruction.SET_FILL_STYLE:
                    lastFillInstruction = instruction;
                    this.alignFill_ = instruction[2];

                    if (pendingFill) {
                        this.fill_(context);
                        pendingFill = 0;
                        if (pendingStroke) {
                            context.stroke();
                            pendingStroke = 0;
                        }
                    }

                    context.fillStyle = /** @type {import("../../colorlike.js").ColorLike} */ (instruction[1]);
                    ++i;
                    break;
                case ol.render.canvas.Instruction.SET_STROKE_STYLE:
                    lastStrokeInstruction = instruction;
                    if (pendingStroke) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    this.setStrokeStyle_(context, /** @type {Array<*>} */ (instruction));
                    ++i;
                    break;
                case ol.render.canvas.Instruction.STROKE:
                    if (batchSize) {
                        pendingStroke++;
                    } else {
                        context.stroke();
                    }
                    ++i;
                    break;
                default:
                    ++i; // consume the instruction anyway, to avoid an infinite loop
                    break;
            }
        }
    }
    if (pendingFill) {
        this.fill_(context);
    }
    if (pendingStroke) {
        context.stroke();
    }
    return undefined;
};

// VFL добавлен атрибут перекрытия
var olRenderCanvasTextReplay = function(tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree) {
    ol.render.canvas.Replay.call(this, tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree);

    /**
     * @private
     * @type {import("../canvas.js").DeclutterGroup}
     */
    this.declutterGroup_;

    /**
     * @private
     * @type {Array<HTMLCanvasElement>}
     */
    this.labels_ = null;

    /**
     * @private
     * @type {string}
     */
    this.text_ = '';

    /**
     * @private
     * @type {number}
     */
    this.textOffsetX_ = 0;

    /**
     * @private
     * @type {number}
     */
    this.textOffsetY_ = 0;

    /**
     * @private
     * @type {boolean|undefined}
     */
    this.textRotateWithView_ = undefined;

    /**
     * @private
     * @type {number}
     */
    this.textRotation_ = 0;

    /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */
    this.textFillState_ = null;

    /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */
    this.fillStates = {};

    /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */
    this.textStrokeState_ = null;

    /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */
    this.strokeStates = {};

    /**
     * @private
     * @type {import("../canvas.js").TextState}
     */
    this.textState_ = /** @type {import("../canvas.js").TextState} */ ({});

    /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */
    this.textStates = {};

    /**
     * @private
     * @type {string}
     */
    this.textKey_ = '';

    /**
     * @private
     * @type {string}
     */
    this.fillKey_ = '';

    /**
     * @private
     * @type {string}
     */
    this.strokeKey_ = '';

    /**
     * @private
     * @type {Object<string, Object<string, number>>}
     */
    this.widths_ = {};

    // VFL атрибут перекрытия
    /**
     * @private
     * @type {boolean}
     */
    this.textOverlap_ = true;

    ol.render.canvas.labelCache.prune();

};

olRenderCanvasTextReplay.prototype = {};

ol.inherits(olRenderCanvasTextReplay, ol.render.canvas.TextReplay);

// VFL добавлен атрибут перекрытия
ol.render.canvas.TextReplay.prototype.drawTextImage_ = function (label, begin, end) {
    var textState = this.textState_;
    var strokeState = this.textStrokeState_;
    var pixelRatio = this.pixelRatio;
    var align = ol.render.TEXT_ALIGN[textState.textAlign || ol.render.canvas.defaultTextAlign];
    var baseline = ol.render.TEXT_ALIGN[textState.textBaseline];
    var strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;

    var anchorX = align * label.width / pixelRatio + 2 * (0.5 - align) * strokeWidth;
    var anchorY = baseline * label.height / pixelRatio + 2 * (0.5 - baseline) * strokeWidth;
    // VFL атрибут перекрытия
    var overlap = !!this.textOverlap_;
    // VFL в инструкцию добавлен атрибут перекрытия
    this.instructions.push([ol.render.canvas.Instruction.DRAW_IMAGE, begin, end,
        label, (anchorX - this.textOffsetX_) * pixelRatio, (anchorY - this.textOffsetY_) * pixelRatio,
        this.declutterGroup_, label.height, 1, 0, 0, this.textRotateWithView_, this.textRotation_,
        1, label.width,
        textState.padding == ol.render.canvas.defaultPadding ?
            ol.render.canvas.defaultPadding : textState.padding.map(function (p) {
                return p * pixelRatio;
            }),
        !!textState.backgroundFill, !!textState.backgroundStroke, overlap
    ]);
    // VFL в инструкцию добавлен атрибут перекрытия
    this.hitDetectionInstructions.push([ol.render.canvas.Instruction.DRAW_IMAGE, begin, end,
        label, (anchorX - this.textOffsetX_) * pixelRatio, (anchorY - this.textOffsetY_) * pixelRatio,
        this.declutterGroup_, label.height, 1, 0, 0, this.textRotateWithView_, this.textRotation_,
        1 / pixelRatio, label.width, textState.padding,
        !!textState.backgroundFill, !!textState.backgroundStroke, overlap
    ]);
};

// VFL добавлен атрибут перекрытия
ol.render.canvas.TextReplay.prototype.setTextStyle = function (textStyle, declutterGroup) {
    var textState, fillState, strokeState;
    if (!textStyle) {
        this.text_ = '';
    } else {
        this.declutterGroup_ = /** @type {import("../canvas.js").DeclutterGroup} */ (declutterGroup);

        var textFillStyle = textStyle.getFill();
        if (!textFillStyle) {
            fillState = this.textFillState_ = null;
        } else {
            fillState = this.textFillState_;
            if (!fillState) {
                fillState = this.textFillState_ = /** @type {import("../canvas.js").FillState} */ ({});
            }
            fillState.fillStyle = ol.colorlike.asColorLike(
                textFillStyle.getColor() || ol.render.canvas.defaultFillStyle);
        }

        var textStrokeStyle = textStyle.getStroke();
        if (!textStrokeStyle) {
            strokeState = this.textStrokeState_ = null;
        } else {
            strokeState = this.textStrokeState_;
            if (!strokeState) {
                strokeState = this.textStrokeState_ = /** @type {import("../canvas.js").StrokeState} */ ({});
            }
            var lineDash = textStrokeStyle.getLineDash();
            var lineDashOffset = textStrokeStyle.getLineDashOffset();
            var lineWidth = textStrokeStyle.getWidth();
            var miterLimit = textStrokeStyle.getMiterLimit();
            strokeState.lineCap = textStrokeStyle.getLineCap() || ol.render.canvas.defaultLineCap;
            strokeState.lineDash = lineDash ? lineDash.slice() : ol.render.canvas.defaultLineDash;
            strokeState.lineDashOffset =
                lineDashOffset === undefined ? ol.render.canvas.defaultLineDashOffset : lineDashOffset;
            strokeState.lineJoin = textStrokeStyle.getLineJoin() || ol.render.canvas.defaultLineJoin;
            strokeState.lineWidth =
                lineWidth === undefined ? ol.render.canvas.defaultLineWidth : lineWidth;
            strokeState.miterLimit =
                miterLimit === undefined ? ol.render.canvas.defaultMiterLimit : miterLimit;
            strokeState.strokeStyle = ol.colorlike.asColorLike(
                textStrokeStyle.getColor() || ol.render.canvas.defaultStrokeStyle);
        }

        textState = this.textState_;
        var font = textStyle.getFont() || ol.render.canvas.defaultFont;
        ol.render.canvas.checkFont(font);
        var textScale = textStyle.getScale();
        textState.overflow = textStyle.getOverflow();
        textState.font = font;
        textState.maxAngle = textStyle.getMaxAngle();
        textState.placement = textStyle.getPlacement();
        textState.textAlign = textStyle.getTextAlign();
        textState.textBaseline = textStyle.getTextBaseline() || ol.render.canvas.defaultTextBaseline;
        textState.backgroundFill = textStyle.getBackgroundFill();
        textState.backgroundStroke = textStyle.getBackgroundStroke();
        textState.padding = textStyle.getPadding() || ol.render.canvas.defaultPadding;
        textState.scale = textScale === undefined ? 1 : textScale;

        var textOffsetX = textStyle.getOffsetX();
        var textOffsetY = textStyle.getOffsetY();
        var textRotateWithView = textStyle.getRotateWithView();
        var textRotation = textStyle.getRotation();
        // VFL атрибут перекрытия
        var textOverlap = textStyle.getOverlap();
        this.text_ = textStyle.getText() || '';
        this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
        this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
        this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
        this.textRotation_ = textRotation === undefined ? 0 : textRotation;
        // VFL атрибут перекрытия
        this.textOverlap_ = textOverlap !== undefined ? textOverlap : true;

        this.strokeKey_ = strokeState ?
            (typeof strokeState.strokeStyle == 'string' ? strokeState.strokeStyle : ol.getUid(strokeState.strokeStyle)) +
            strokeState.lineCap + strokeState.lineDashOffset + '|' + strokeState.lineWidth +
            strokeState.lineJoin + strokeState.miterLimit + '[' + strokeState.lineDash.join() + ']' :
            '';
        this.textKey_ = textState.font + textState.scale + (textState.textAlign || '?');
        this.fillKey_ = fillState ?
            (typeof fillState.fillStyle == 'string' ? fillState.fillStyle : ('|' + ol.getUid(fillState.fillStyle))) :
            '';
    }
};

// VFL прокидывание layer
ol.renderer.canvas.ImageLayer.prototype.forEachFeatureAtCoordinate = function (coordinate, frameState, hitTolerance, callback, layer) {
    if (this.vectorRenderer_) {
        return this.vectorRenderer_.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, undefined, layer);
    } else {
        return ol.renderer.canvas.IntermediateCanvas.prototype.forEachFeatureAtCoordinate.call(this, coordinate, frameState, hitTolerance, callback, undefined, layer);
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/~/openlayers/oms/allowoverlap.js
// module id = 27
// module chunks = 0